import { useDevice } from "../../../../useDevice";
import Box from "../../../Box";
import InlineBlankFields, { type InlineBlankField } from "../InlineBlankFields";
import { ItemInstruction } from "./pte/ItemInstruction";

type Props = {
	instruction: string;
	stem: string;
	fields: InlineBlankField[];
	values?: Record<string, string>;
	defaultValues?: Record<string, string>;
	onChangeValues?: (values: Record<string, string>) => void;
	disabled?: boolean;
	correctValues?: Record<string, string>;
};

const FillInTheBlanksDropdown = ({
	instruction,
	stem,
	fields,
	values,
	defaultValues,
	onChangeValues,
	disabled,
	correctValues,
}: Props) => {
	const { isMobile } = useDevice();
	return (
		<Box gap={isMobile ? 16 : 24}>
			<ItemInstruction instruction={instruction} />
			<Box paddingHorizontal={isMobile ? 16 : 0}>
				<InlineBlankFields
					stemText={stem}
					fields={fields}
					values={values}
					defaultValues={defaultValues}
					onChangeValues={onChangeValues}
					disabled={disabled}
					correctValues={correctValues}
				/>
			</Box>
		</Box>
	);
};

export default FillInTheBlanksDropdown;
